/**
 * Enumeration for the different change modes in RDT.
 *
 * @readonly
 * @enum {string}
 */
export const RdtChangeMode = {
    UP: 'UP',
    DOWN: 'DOWN',
    CONSTANT: 'CONSTANT'
}
Object.freeze(RdtChangeMode)
